import type React from 'react';
import { useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CoachCardLarge } from '@features/coaches/coachCard/Large/ui';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { ListBody, PageHead } from '@shared/ui/index';
import { useCoachQuery } from '@src/api/api-hooks/coaches/useCoachQuery.ts';
import { Loader } from '@src/library/components/common';

export const CoachPage: React.FC = () => {
  const { coachId } = useParams();

  const { data: coachData, isFetching: isCoachFetching } = useCoachQuery({ id: coachId });

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isCoachFetching) {
    return <Loader />;
  }

  if (coachData) {
    return (
      <>
        {/*<Header MCenter={<>Специалист</>} menuClassName={shared.hide}/>*/}
        <PageHead Left={<PageBackButton />} Center={'Специалист'} />
        <ListBody>
          <CoachCardLarge {...coachData} />
        </ListBody>
        ;
      </>
    );
  }

  return 'Error';
};
